import React from "react";
import { usePhoneTheme } from "../ForBrands/useIsPhone";

// The performance pages' data attribution. Kobi, 10/21: "Please include
// 'Performance data provided by Cerebro Sports' at the bottom of the
// performance page. Make it in grey (not black) font and please don't
// exaggerate the size of the font too large. Small is fine." (Jayson: the
// player archetypes and the impact rating are CACHE's; every other stat and
// metric on the page derives from the league feed.)
//
// One small grey line of plain text (no link, no logo), centred under the
// section as its footnote, the way the public card's "Powered by CACHE"
// closes that page: the V2 caption size on desktop (bm-body-s) and the phone
// caption size inside the phone theme (bm-body-xs, as the box score's "Stats
// from" line), so it is never larger than the captions around it. The pages
// draw it once, at the very bottom of the Performance tab (the athlete
// profile's and the coach Team page's), and only while the league feed's
// data is on screen (athletePerformanceModel.performanceAttributed,
// teamPerformanceModel.teamPerformanceAttributed); never on a card, another
// tab or the public card.
//
// PERFORMANCE_ATTRIBUTION is the one string in the client components that
// names a data provider: the client-copy guard (n1019C6Wording) allows it
// in this file only.
export const PERFORMANCE_ATTRIBUTION = "Performance data provided by Cerebro Sports";

const PerformanceAttribution = () => {
  const phone = usePhoneTheme();
  return <p className={`pt-2 text-center text-bm-muted ${phone ? "bm-body-xs" : "bm-body-s"}`}>{PERFORMANCE_ATTRIBUTION}</p>;
};

export default PerformanceAttribution;
